import { API_BASE_URL } from "./api";

const AUTH_KEYS = [
  "authenticated",
  "userId",
  "session_token",
  "userName",
  "userEmail",
];

const setAuthItem = (key, value) => {
  if (value !== undefined && value !== null) {
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  }
};

const getAuthItem = (key) => {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
};

const clearAuthItems = () => {
  AUTH_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
};

const hydrateSessionStorage = () => {
  AUTH_KEYS.forEach((key) => {
    const localValue = localStorage.getItem(key);
    const sessionValue = sessionStorage.getItem(key);

    if (!sessionValue && localValue) {
      sessionStorage.setItem(key, localValue);
    }
  });
};

// Authentication service using fetch
class AuthService {
  async login(credentials) {
    const response = await fetch(`${API_BASE_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    const data = await response.json();

    if (response.ok) {
      const userObj = data.user || data;
      const nameToStore = userObj.name || userObj.username || "User";
      const emailToStore = userObj.email || credentials.identifier || "";

      setAuthItem("authenticated", "true");
      setAuthItem("userId", data.userId || userObj.id);
      setAuthItem("session_token", data.session_token);
      setAuthItem("userName", nameToStore);
      setAuthItem("userEmail", emailToStore);
    }

    return { response, data };
  }

  async register(userData) {
    const response = await fetch(`${API_BASE_URL}/api/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();
    return { response, data };
  }

  async requestPasswordReset(email) {
    const response = await fetch(`${API_BASE_URL}/api/request-password-reset`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    return { response, data };
  }

  async resetPassword(sessionToken, password) {
    const response = await fetch(`${API_BASE_URL}/api/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_token: sessionToken, password }),
    });

    const data = await response.json();
    return { response, data };
  }

  logout() {
    clearAuthItems();
    sessionStorage.removeItem("session_dataset_ids");
    sessionStorage.removeItem("mode");
    sessionStorage.removeItem("framework");
  }

  isAuthenticated() {
    hydrateSessionStorage();
    return getAuthItem("authenticated") === "true";
  }

  getUserId() {
    hydrateSessionStorage();
    return getAuthItem("userId");
  }

  getSessionToken() {
    hydrateSessionStorage();
    return getAuthItem("session_token");
  }

  getUserName() {
    hydrateSessionStorage();
    return getAuthItem("userName");
  }

  getUserEmail() {
    hydrateSessionStorage();
    return getAuthItem("userEmail");
  }

  hydrateSessionStorage() {
    hydrateSessionStorage();
  }

  clearAuthItems() {
    clearAuthItems();
  }
}

const authService = new AuthService();

export default authService;
